import { Paper, Tabs } from "@mantine/core";
import { useNavigate, useParams } from "react-router";
import { PageContent } from "../../components/BuildingBlocks/Layout/PageContent/PageContent";
import { PageHeader } from "../../components/BuildingBlocks/Layout/PageHeader/PageHeader";
import { LoadOrError } from "../../components/LoadOrError/LoadOrError";
import { useVariantDetail } from "../../hooks/useVariantDetail";
import { PARAGRAPH_6_TABS } from "./Paragraph6.constants";
import { Paragraph6ContractPage } from "./Paragraph6ContractPage/Paragraph6ContractPage";
import { Paragraph6CreditNumberRangesPage } from "./Paragraph6CreditNumberRangesPage/Paragraph6CreditNumberRangesPage";
import { Paragraph6CreditsPage } from "./Paragraph6CreditsPage/Paragraph6CreditsPage";

export const DEFAULT_SUBPAGE = PARAGRAPH_6_TABS.CONTRACTS;

interface Paragraph6ViewProps {
  variantId: number;
  projectId: string;
}

function Paragraph6View({ variantId, projectId }: Paragraph6ViewProps) {
  const { tab: activeTab } = useParams();
  const navigate = useNavigate();

  const {
    isLoading: paymentInformationIsLoading,
    error: paymentInformationError,
    variantDetail
  } = useVariantDetail(variantId);

  const usePaymentInformation =
    variantDetail?.paragraph_6_payment_information_instead_of_credit;

  const isUsingPaymentInformation =
    usePaymentInformation === true &&
    !paymentInformationIsLoading &&
    !paymentInformationError;
  const isUsingCredits =
    usePaymentInformation === false &&
    !paymentInformationIsLoading &&
    !paymentInformationError;

  return (
    <PageContent className="Paragraph6View">
      <PageHeader title="§ 6 EEG" />
      <Paper>
        <Tabs value={activeTab} onChange={(newTab) => navigate(`../${newTab}`)}>
          <Tabs.List>
            <Tabs.Tab component="a" value={PARAGRAPH_6_TABS.CONTRACTS}>
              Verträge
            </Tabs.Tab>
            <LoadOrError loading={paymentInformationIsLoading}>
              {isUsingCredits && (
                <>
                  <Tabs.Tab component="a" value={PARAGRAPH_6_TABS.CREDITS}>
                    Gutschriften
                  </Tabs.Tab>
                  <Tabs.Tab
                    component="a"
                    value={PARAGRAPH_6_TABS.CREDIT_NUMBER_RANGES}
                  >
                    Gutschriftennummernkreise
                  </Tabs.Tab>
                </>
              )}
              {isUsingPaymentInformation && (
                <Tabs.Tab
                  component="a"
                  value={PARAGRAPH_6_TABS.PAYMENT_INFORMATION}
                >
                  Zahlungsinformationen
                </Tabs.Tab>
              )}
            </LoadOrError>
          </Tabs.List>
          <Tabs.Panel value={PARAGRAPH_6_TABS.CONTRACTS}>
            <Paragraph6ContractPage
              projectId={projectId}
              variantId={variantId}
            />
          </Tabs.Panel>
          <Tabs.Panel value={PARAGRAPH_6_TABS.CREDITS}>
            <Paragraph6CreditsPage
              projectId={projectId}
              variantId={variantId}
            />
          </Tabs.Panel>
          <Tabs.Panel value={PARAGRAPH_6_TABS.CREDIT_NUMBER_RANGES}>
            <Paragraph6CreditNumberRangesPage variantId={variantId} />
          </Tabs.Panel>
          <Tabs.Panel value={PARAGRAPH_6_TABS.PAYMENT_INFORMATION}>
            <Paragraph6CreditsPage
              projectId={projectId}
              variantId={variantId}
            />
          </Tabs.Panel>
        </Tabs>
      </Paper>
    </PageContent>
  );
}

export { Paragraph6View, Paragraph6ViewProps };
